import React from 'react';
const facts = [{
  value: '16',
  label: 'Tygodni zaplanowanych'
}, {
  value: '5',
  label: 'Darmowych bonusów'
}, {
  value: '50',
  label: 'Gotowych ćwiczeń'
}, {
  value: 'PDF',
  label: 'Natychmiast na e-mail'
}];
export function TrustBar() {
  return <section aria-label="Najważniejsze informacje" className="bg-forest" data-id="element-239" data-mp="y6mm6rsy778v">
      <div className="mx-auto max-w-shell px-5 py-8 sm:px-6 sm:py-10" data-id="element-240" data-mp="138bx87g67kwy">
        <ul className="grid grid-cols-2 overflow-hidden rounded-lg border border-forest-soft lg:grid-cols-4" data-id="element-241" data-mp="1qx4z0kjh4mzh">
          {facts.map((fact, index) => <li key={fact.label} className={`bg-forest-soft/40 px-3 py-6 text-center sm:py-8 ${index % 2 === 0 ? 'border-r' : ''} ${index < 2 ? 'border-b lg:border-b-0' : ''} border-forest-soft lg:border-r lg:last:border-r-0`} data-id="element-242" data-mp="1uwvsiw0dxh7p" data-mpi={index}>
              <p className="font-display text-4xl font-extrabold leading-none text-gold sm:text-5xl" data-id="element-243" data-mp="5mekyrsdwbtg">{fact.value}</p>
              <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.14em] text-white/80 sm:text-xs" data-id="element-244" data-mp="1aix3z7tlcan4">
                {fact.label}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}